module.exports = __webpack_public_path__ + "img/kitkitphoto10.3d95dba9.jpg";